<template>
<div class="chapter">
<div class="inner_page">
<table class="chapter-title-corner-decorations" width="100%"><tbody><tr><td class="chapter-title-corner-decoration-left-column"><div class="chapter-title-corner-decoration-left-column"><img alt="image" class="chapter-title-corner-decoration-left" src="d2d_images/chapter_title_corner_decoration_left.png"/></div></td><td class="chapter-title-corner-decoration-middle-column"> </td><td class="chapter-title-corner-decoration-right-column"><div class="chapter-title-corner-decoration-right-column"><img alt="image" class="chapter-title-corner-decoration-right" src="d2d_images/chapter_title_corner_decoration_right.png"/></div></td></tr></tbody></table><div class="chapter-title"><div class="chapter-title-decoration-above"><div class="chapter-title-decoration-above-inner"><img alt="image" class="chapter-title-decoration-above" src="d2d_images/chapter_title_above.png"/></div></div><h1 class="chapter-title">Fortaleciendo Los Cimientos</h1>
<h1>Stephanie Albright</h1>
<div class="chapter-title-decoration-below"><div class="chapter-title-decoration-below-inner"><img alt="image" class="chapter-title-decoration-below" src="d2d_images/chapter_title_below.png"/></div></div></div><p class="section-break">––––––––</p><div class="decoration-scene-break"><div class="decoration-scene-break-inner"><img alt="image" class="decoration-scene-break" src="d2d_images/scene_break.png"/></div></div>
<p style="font-size: x-large; text-align: center; text-indent: 0">Traducido por mislibrosencastellano </p>
<p class="first-in-scene" style="page-break-before: always"><span class="first-scene-phrase"><span class="first-in-scene with-quote character-f">“F</span>ortaleciendo Los Cimientos”</span></p>
<p>Escrito por Stephanie Albright</p>
<p>Copyright © 2022 Stephanie Albright</p>
<p>Todos los derechos reservados</p>
<p>Distribuido por Babelcube, Inc. </p>
<p>www.babelcube.com </p>
<p>Traducido por mislibrosencastellano</p>
<p>“Babelcube Books” y “Babelcube” son marcas registradas de Babelcube Inc.</p>
<p style="font-size: xx-large; page-break-before: always; text-align: center; text-indent: 0">Fortaleciendo Los Cimientos</p>
<p style="font-size: xx-large; text-align: center; text-indent: 0">Pulso – Electromagnético PEM</p>
<p style="font-size: xx-large; page-break-before: always; text-align: center; text-indent: 0">Stephanie Albright</p>
<p style="font-size: x-large; page-break-before: always; text-align: center; text-indent: 0">Esta es una obra de ficción. Cualquier parecido con personas reales, vivas o muertas, o eventos reales es pura coincidencia.</p>
<p style="font-style: italic; page-break-before: always; text-align: right">¡A mis lectores! Nunca podré agradecerles lo suficiente. </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c001.vue?02b7cb06